import { useEffect, useRef, useState } from "react";
import { getImageLoading } from "../../../../helpers/image-helper";
import { TImage } from "../../../../types";
import styles from "./top-image.module.less";
import animations from "../../../../animation/animation.module.less";

type TTopImageProps = {
  imageDesktop?: TImage;
  imageMobile?: TImage;
  blockIndex?: number;
};

export const TopImage = ({ imageDesktop, imageMobile, blockIndex }: TTopImageProps) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const imageRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const interval = null;

    if (imageRef.current?.complete) {
      setImageLoaded(true);
    } else {
      const interval = setInterval(() => {
        if (imageRef.current?.complete) {
          setImageLoaded(true);
          clearInterval(interval);
        }
      }, 250);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);

  return (
    <div className={styles.wrapper}>
      {(imageDesktop?.url || imageMobile?.url) && (
        <picture>
          <source srcSet={imageMobile?.url} media="(max-width: 767px)" />
          <source srcSet={imageDesktop?.url} media="(min-width: 768px)" />
          <img
            ref={imageRef}
            src={imageDesktop?.url}
            className={[styles.image, imageLoaded ? animations.fadeIn : animations.opacity0].join(" ")}
            alt={imageMobile?.alt || imageDesktop?.alt}
            loading={getImageLoading(blockIndex ?? 0)}
          />
        </picture>
      )}
    </div>
  );
};
